import React from "react";
import "../Biography.css"; // shared biography styles

const PhyllisLeiFurumoto = () => {
  return (
    <section className="biography-section">
      
        {/* Biography Text */}
        <div className="bio-text">
  <img 
    src={`${process.env.PUBLIC_URL}/images/Phyllis_Lei_Furumoto.webp`} 
    alt="Phyllis Lei Furumoto"
    className="bio-inline-photo"
  />
  <h2>Biography of Phyllis Lei Furumoto (1948–2019)</h2>
  <h3 className="subtitle">Reiki Grandmaster & Lineage Bearer</h3>

  {/* Early Life */}
  <h3>Early Life</h3>
        <p>
          Phyllis Lei Furumoto was born in 1948 in the Hawaiian Islands, into a family deeply 
          influenced by Japanese traditions and the unique multicultural environment of Hawaii. 
          Her grandmother was <strong>Hawayo Takata</strong>, the woman who brought Reiki to the West. 
          As a child, Phyllis grew up in close connection to her grandmother and 
          often observed her healing practices, though she did not yet fully understand 
          the depth of Reiki at that time.
        </p>
        <p>
          She inherited not only her grandmother's cultural heritage but also the deep spiritual 
          curiosity and compassion that would later define her life's work. 
        </p>

        {/* Connection with Reiki */}
        <h3>Discovering Reiki</h3>
        <p>
          As a young woman, Phyllis sought her own path, exploring life, love, and different 
          ways of being. But the presence of her grandmother and Reiki was always in the background. 
          In the late 1970s, her life took a pivotal turn when she became more directly involved 
          with Reiki through <strong>Hawayo Takata's personal guidance</strong>. 
        </p>
        <p>
          She experienced firsthand the healing, the simplicity, and the transformative nature of Reiki. 
          Under Takata's mentorship, she began to realize that Reiki was not only a healing technique, 
          but also a spiritual practice and a way of life. 
        </p>

        {/* Passing of Hawayo Takata */}
        <h3>After the Passing of Hawayo Takata</h3>
        <p>
          In December 1980, when Hawayo Takata passed away, she left behind a growing 
          community of Reiki practitioners. However, there was uncertainty about who would 
          continue her work as the head of the Reiki lineage. 
        </p>
        <p>
          After reflection and recognition from Takata's students, <strong>Phyllis Furumoto 
          stepped forward to carry the mantle of Reiki Grandmaster</strong> and became known as 
          the Lineage Bearer of Usui Shiki Ryoho. This was not only a title, 
          but a responsibility to safeguard, transmit, and evolve Reiki as a spiritual path. 
        </p>

        {/* Teaching and Leadership */}
        <h3>Teaching and Leadership</h3>
        <p>
          From the early 1980s onward, Phyllis dedicated her life to teaching Reiki worldwide. 
          She traveled across continents, offering treatments, initiating students, 
          and training Reiki Masters. Her work emphasized both the **practical healing aspects** 
          of Reiki and its deeper **spiritual dimension** as a path of self-discovery. 
        </p>
        <p>
          She became known for her warmth, openness, and authenticity in teaching. 
          Unlike a rigid authority figure, she related to her students as a guide, 
          a companion on the spiritual journey. She often spoke of Reiki not as something 
          she owned, but as a living tradition flowing through her to others. 
        </p>

        {/* Philosophy */}
        <h3>Philosophy and Vision</h3>
        <p>
          Phyllis articulated the understanding that Reiki was more than a technique - 
          it was a **way of living** in harmony with oneself, with others, and with the universe. 
          She upheld the **five Reiki principles** as a daily guide to balance, gratitude, 
          and compassion. 
        </p>
        <p>
          She also encouraged practitioners to integrate Reiki into daily life rather 
          than treating it as a separate spiritual activity. Through this approach, 
          Reiki became for many a natural part of their lifestyle, a means to heal not 
          only physical ailments but also emotional and spiritual wounds. 
        </p>

        {/* Global Work */}
        <h3>Global Expansion of Reiki</h3>
        <p>
          Over nearly four decades, Phyllis trained hundreds of Reiki Masters and countless 
          practitioners across the world. She worked tirelessly to preserve the **oral tradition 
          of Reiki**, sharing stories, practices, and experiences that connected students 
          directly to the lineage of Mikao Usui, Chujiro Hayashi, and Hawayo Takata. 
        </p>
        <p>
          She also engaged in dialogues with other Reiki lineages and healing traditions, 
          fostering unity while respecting diversity. Her vision was to see Reiki thrive 
          as a universal spiritual practice for all humanity. 
        </p>

        {/* Later Years */}
        <h3>Later Years and Passing</h3>
        <p>
          In her later years, Phyllis continued to teach, travel, and nurture her global community, 
          even while facing health challenges. She was candid about her struggles, 
          teaching that vulnerability and honesty were essential aspects of spiritual life. 
        </p>
        <p>
          On <strong>31 March 2019</strong>, Phyllis Lei Furumoto passed away, leaving behind 
          a worldwide network of Reiki practitioners, teachers, and masters who carry forward 
          her vision. 
        </p>

        {/* Legacy */}
        <h3>Legacy of Phyllis Lei Furumoto</h3>
        <p>
          Phyllis's legacy lives on in the thousands of practitioners she inspired 
          and in the countless lives transformed through Reiki. 
          As the recognized Lineage Bearer of Usui Shiki Ryoho, 
          she preserved the spiritual essence of Reiki while also allowing it to evolve 
          in a modern, global context. 
        </p>
        <ul>
          <li><strong>Grandmaster of Usui Shiki Ryoho</strong>, safeguarding the lineage after Takata.</li>
          <li><strong>Global Teacher and Healer</strong>, bringing Reiki to students worldwide.</li>
          <li><strong>Bridge between East and West</strong>, continuing the work of her grandmother.</li>
          <li><strong>Spiritual Leader</strong>, who embodied Reiki as a way of life, not just a practice.</li>
        </ul>

        {/* Conclusion */}
        <h3>Conclusion</h3>
        <p>
          Phyllis Lei Furumoto (1948-2019) was not only the granddaughter of Hawayo Takata 
          but also a spiritual leader in her own right. Through her dedication, compassion, 
          and vision, she ensured that Reiki continued as a living practice of healing 
          and spiritual growth. 
        </p>
        <p>
          Today, her teachings remain alive in the hands and hearts of practitioners worldwide, 
          continuing the lineage that began with Mikao Usui. 
        </p>
      </div>
      
    </section>
  );
};

export default PhyllisLeiFurumoto;
